import { faqCollectionBodySchema } from "@redotech/redo-support-common/faq/faq-body-schema";
import * as z from "zod";

export const createCollection = {
  name: "createCollection" as const,
  input: z.object({
    title: z.string(),
    description: z.string(),
    published: z.boolean(),
  }),
  output: z.union([
    z.object({ success: z.literal(true), data: faqCollectionBodySchema }),
    z.object({ success: z.literal(false), error: z.string() }),
  ]),
};
